import { render, staticRenderFns } from "./BiddingCompanyCertificate.vue?vue&type=template&id=0799cbdf&scoped=true&"
import script from "./BiddingCompanyCertificate.vue?vue&type=script&lang=js&"
export * from "./BiddingCompanyCertificate.vue?vue&type=script&lang=js&"
import style0 from "./BiddingCompanyCertificate.vue?vue&type=style&index=0&id=0799cbdf&lang=scss&scoped=true&"
import style1 from "./BiddingCompanyCertificate.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0799cbdf",
  null
  
)

export default component.exports